import classNames from 'classnames';
import React, { PropsWithChildren, useState } from 'react';
import Button, { ButtonProps } from 'react-bootstrap/esm/Button';
import { ConfirmModal, IConfirmModalProps } from '../confirm-modal/ConfirmModal';

interface IConfirmationButtonProps {
  variant: ButtonProps['variant'];
  className?: string;
  modalTitle: IConfirmModalProps['title'];
  modalBody: IConfirmModalProps['body'];
  modalConfirmButtonStyle?: IConfirmModalProps['confirmButtonStyle'];
  modalConfirmLabel?: IConfirmModalProps['confirmLabel'];
  onClick: () => void;
}

export const ConfirmationButton = ({ className, variant, modalTitle, modalBody, modalConfirmButtonStyle, modalConfirmLabel, onClick, children }: PropsWithChildren<IConfirmationButtonProps>): JSX.Element => {
  const [open, setOpen] = useState(false);

  return <>
    <Button className={classNames('confirmation-button', className)} type="button" variant={variant} onClick={() => setOpen(true)}>{children}</Button>
    { open && <ConfirmModal title={modalTitle} body={modalBody}
      onCancel={() => setOpen(false)}
      onConfirm={() => onClick()}
      confirmButtonStyle={modalConfirmButtonStyle}
      confirmLabel={modalConfirmLabel}
    /> }
  </>;
};
